import React from 'react';
import { Helmet } from 'react-helmet';
import PageHeader from '../../Components/common/PageHeader';
import ServiceContainer01 from '../../Containers/ServiceContainers/ServiceContainer01';
import './Services01.css'; // Creiamo un nuovo file CSS per gli stili

const Services01 = ({ 
    location = '', 
    serviceTitle = '', 
    seoTitle = '',
    description = '',
    longDescription = '',
    benefits = [],
    features = []
}) => {
    // Convertiamo e sanitizziamo i valori
    const safeTitle = (seoTitle || serviceTitle || '').toString();
    const safeDescription = (description || '').toString();
    const safeLocation = (location || '').toString();
    const safeServiceTitle = (serviceTitle || '').toString();
    
    // Costruiamo la meta description solo se abbiamo i valori necessari
    const metaDescription = safeDescription || (
        safeServiceTitle ? 
        `${safeServiceTitle}${safeLocation ? ` a ${safeLocation.replace('-', ' ').toUpperCase()}` : ''} - RB Costruzioni offre servizi professionali di ${safeServiceTitle.toLowerCase()}` :
        'RB Costruzioni - Servizi professionali di costruzione'
    );

    return (
        <>
            <Helmet defer={false}>
                <title>
                    {safeTitle ? `${safeTitle} | RB Costruzioni` : 'RB Costruzioni'}
                </title>
                <meta name="description" content={metaDescription} />
                {safeLocation && (
                    [
                        <meta key="region" name="geo.region" content="IT" />,
                        <meta key="placename" name="geo.placename" content={safeLocation.replace('-', ' ')} />
                    ]
                )}
            </Helmet>

            <div className="services-page">
                <PageHeader 
                    activeClass01='active' 
                    activeClass02='d-none' 
                    routeName01='Servizi' 
                    heading={safeServiceTitle || 'Servizi'} 
                />
                <ServiceContainer01 
                    description={longDescription}
                    benefits={benefits}
                    features={features}
                />
            </div>
        </>
    );
};

export default Services01;